var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useMemo } from 'react';
import withProps from '../HoC/withProps';
import { RowActionsCell } from '../components/gridCells';
import { EditReadPosition } from '../types';
var useEditReadAsColumn = function (props) {
    var _a;
    var onRowAction = props.onRowAction, actionColumnDefinition = props.actionColumnDefinition, columnsDefinitions = props.columnsDefinitions, gridSelectors = props.gridSelectors, gridActions = props.gridActions, onRowEditClick = props.onRowEditClick, onRowReadClick = props.onRowReadClick;
    var modifiedOnRowAction = useCallback(function (id, field, value, rowData) {
        if (field === 'row_edit' || field === 'row_read') {
            if (field === 'row_edit' && onRowEditClick)
                onRowEditClick(id, value);
            if (field === 'row_read' && onRowReadClick)
                onRowReadClick(id, value);
        }
        else if (onRowAction) {
            return onRowAction(id, field, value, rowData);
        }
    }, [onRowAction, onRowEditClick, onRowReadClick]);
    var _b = actionColumnDefinition || {}, canRowEdit = _b.canRowEdit, canRowRead = _b.canRowRead, addRowNumbers = _b.addRowNumbers, _c = _b.stickTo, stickTo = _c === void 0 ? 'left' : _c, _d = _b.flexBasis, flexBasis = _d === void 0 ? 20 : _d;
    var withCheckboxes = !!((_a = actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.actionOptions) === null || _a === void 0 ? void 0 : _a.length) || (actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.forceCheckboxes);
    var hasActions = canRowEdit || canRowRead || withCheckboxes || addRowNumbers;
    var modifiedColumnsDefinitions = useMemo(function () {
        var _a;
        var editReadColumnDefinition = {
            name: 'actions-cell-cg',
            flexBasis: flexBasis,
            filtering: withCheckboxes || addRowNumbers,
            filteringType: 'actions',
            sorting: false,
            sticky: !!hasActions,
            stickTo: stickTo,
            alwaysOn: true,
            cellComponent: withProps({
                actionColumnDefinition: actionColumnDefinition,
                withCheckboxes: withCheckboxes,
                addRowNumbers: actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.addRowNumbers,
                checkedRows: (_a = gridSelectors === null || gridSelectors === void 0 ? void 0 : gridSelectors.uxState) === null || _a === void 0 ? void 0 : _a.checkedRows,
                onUxChange: gridActions === null || gridActions === void 0 ? void 0 : gridActions.handleUxChange
            })(RowActionsCell)
        };
        if (stickTo === EditReadPosition.Left) {
            return __spreadArray([editReadColumnDefinition], columnsDefinitions, true);
        }
        else {
            return __spreadArray(__spreadArray([], columnsDefinitions, true), [editReadColumnDefinition], false);
        }
    }, [
        addRowNumbers,
        flexBasis,
        stickTo,
        hasActions,
        columnsDefinitions,
        withCheckboxes,
        gridSelectors === null || gridSelectors === void 0 ? void 0 : gridSelectors.uxState,
        actionColumnDefinition,
        gridActions === null || gridActions === void 0 ? void 0 : gridActions.handleUxChange
    ]);
    return {
        columnsDefinitions: modifiedColumnsDefinitions,
        onRowAction: modifiedOnRowAction
    };
};
export default useEditReadAsColumn;
